webpackJsonp([142],{

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v2_config_client__ = __webpack_require__(74);


var platform = {
  getPlatformId: function getPlatformId() {
    var origin = window.location.origin;
    for (var platformId in __WEBPACK_IMPORTED_MODULE_0__v2_config_client__["a" /* default */].origin) {
      if (origin.indexOf(__WEBPACK_IMPORTED_MODULE_0__v2_config_client__["a" /* default */].origin[platformId]) >= 0) {
        return platformId;
      }
    }
    return '1';
  },
  id: global.PLATFORMID,
  qdIds: ['1', '3'],
  qqIds: ['2'],
  androidIds: ['1', '2'],
  iosIds: ['3'],
  isCommonWeb: function isCommonWeb() {
    var useragent = navigator.userAgent.toLocaleLowerCase();
    if (useragent.indexOf('qd') < 0 && useragent.indexOf('qq') < 0) {
      return true;
    } else {
      return false;
    }
  },
  isQd: function isQd() {
    if (platform.qdIds.indexOf(global.PLATFORMID) >= 0) {
      return true;
    } else {
      return false;
    }
  },
  isQq: function isQq() {
    if (platform.qqIds.indexOf(global.PLATFORMID) >= 0) {
      return true;
    } else {
      return false;
    }
  },
  isAndroid: function isAndroid() {
    if (platform.androidIds.indexOf(global.PLATFORMID) >= 0) {
      return true;
    } else {
      return false;
    }
  },
  isIos: function isIos() {
    if (platform.iosIds.indexOf(global.PLATFORMID) >= 0) {
      return true;
    } else {
      return false;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (platform);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mta_h5_analysis__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mta_h5_analysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mta_h5_analysis__);



var performanceLogT = 0;

var sendPerformanceLog = function sendPerformanceLog() {
  var data = {
    pTime: window.performance.timing.toJSON(),
    sign: 'qdActStat' + (parseInt(new Date().getTime() / 1000) / 4).toFixed(2),
    url: encodeURIComponent(window.location.href).toLowerCase(),
    platform: 1
  };
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(global.API_HOST + 'SyAct/Statistic/addPerformanceLog', data).then(function (response) {
    if (response.data.code !== 0) {
      console.log('add pTime failed');
    }
  });
};
/* harmony default export */ __webpack_exports__["a"] = ({
  addRecord: function addRecord(action) {
    var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (url === null) {
      url = window.location.href;
    }
    var requestUrl = global.API_HOST + 'qqread/ad/track?platformId=' + global.PLATFORMID + '&action=' + action + '&origin=' + origin + '&url=' + encodeURIComponent(url);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(requestUrl).then(function (response) {
      if (response.data.code !== 0) {
        console.log('add record failed');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  addMtaEvent: function addMtaEvent(action) {
    __WEBPACK_IMPORTED_MODULE_1_mta_h5_analysis___default.a.clickStat(action, { 'page': document.title });
  },
  addPerformanceLog: function addPerformanceLog() {
    performanceLogT = setInterval(function () {
      if (document.readyState === 'complete') {
        sendPerformanceLog();
        clearInterval(performanceLogT);
      }
    }, 10);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v2_config_client__ = __webpack_require__(74);


var style = {
  cssClassName: '',
  cssBtnColor: '',
  init: function init() {
    style.cssClassName = __WEBPACK_IMPORTED_MODULE_0__v2_config_client__["a" /* default */].cssClassName[global.PLATFORMID];
    style.cssBtnColor = __WEBPACK_IMPORTED_MODULE_0__v2_config_client__["a" /* default */].cssBtnColor[global.PLATFORMID];
    style.cssBgColor = __WEBPACK_IMPORTED_MODULE_0__v2_config_client__["a" /* default */].cssBgColor[global.PLATFORMID];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (style);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(524),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a13c5da8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9989d9ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {global.HOST_API_MOCK = 'https://rap.qidian.com/';

// 根据客户端初始化赋值
global.PLATFORMID = 1;
global.API_HOST = '';
global.WEB_HOST_HTTP = '';
global.APP_HOST = '';
global.APP_NAME = '';
global.COIN_NAME = '';
global.NEW_APP_HOST = '';
global.LY_API_HOST = '';

// mta 根据客户端初始化赋值
global.MTA_SID = '';
global.MTA_CID = '';
global.MTA_HID = '';

// 统计action定义
global.STATISTIC_ACTION_ACCESS = 'access'; // 进入页面
global.STATISTIC_ACTION_ACT = 'act'; // 活动
global.STATISTIC_ACTION_DOWNLOAD = 'download'; // app下载
global.STATISTIC_ACTION_GIFT = 'gift'; // 礼包按钮
global.STATISTIC_ACTION_LOAD = 'load'; // 服务端收到客户端的请求
global.STATISTIC_ACTION_MOREGIFT = 'moreGift'; // 更多礼物
global.STATISTIC_ACTION_OPENAPP = 'openApp'; // 打开app游戏
global.STATISTIC_ACTION_OPENH5 = 'openH5'; // 打开H5游戏
global.STATISTIC_ACTION_OPENINDEX = 'openIndex'; // 游戏详情页打开关联游戏
global.STATISTIC_ACTION_OPENDETAIL = 'openDetail'; // 游戏主页打开游戏详情页
global.STATISTIC_ACTION_DOWNLOADCOMPLETE = 'downloadcomplete'; // 下载完成
global.STATISTIC_ACTION_SHARE = 'share'; // 分享
global.STATISTIC_ACTION_MESSAGE = 'message'; // 消息
global.STATISTIC_ACTION_TEMP = 'temp'; // 临时统计
// 详情页
global.STATISTIC_ACTION_ACTMORE = 'actMore'; // 更多活动
global.STATISTIC_ACTION_ACTAD = 'actAD'; // 点击详情页活动
global.STATISTIC_ACTION_DETAIL_IMG_CLICK = 'detailImgClick'; // 详情页游戏介绍图点击
global.STATISTIC_ACTION_DETAIL_IMG_CLOSE = 'detailImgClose'; // 详情页游戏介绍图关闭
global.STATISTIC_ACTION_DETAIL_IMG_SWIPER = 'detailImgSwiper'; // 详情页游戏介绍图滑动
global.STATISTIC_ACTION_BACK = 'back'; // 退出页面
global.STATISTIC_ACTION_DETAIL_GAME_MORE = 'detailGameMore'; // 详情页更多游戏
// 底部栏
global.STATISTIC_ACTION_BOTTOM = 'bottom'; // 底部菜单栏
global.STATISTIC_ACTION_BOTTOM_ACT_RED = 'bottomActRed'; // 底部菜单栏活动红点
global.STATISTIC_ACTION_BOTTOM_MINE_RED = 'bottomMineRed'; // 底部菜单栏我的红点
// 分类
global.STATISTIC_ACTION_CATEGORY_TOP_HREF = 'categoryTopHref'; // 分类顶部导航1-7
global.STATISTIC_ACTION_CATEGORY_BANNER_CLICK = 'categoryBannerClick'; // 分类banner图点击
global.STATISTIC_ACTION_CATEGORY_BANNER_SHOW = 'categoryBannerShow'; // 分类banner图点击
global.STATISTIC_ACTION_CATEGORY_CARD = 'categoryCard'; // 分类card
// global.STATISTIC_ACTION_CATEGORY_BUTTON = 'categoryButton' // 分类按钮
// 活动专区
global.STATISTIC_ACTION_ACT_PAGE = 'actPage'; // 活动专区活动分页 1 活动 2 预约
global.STATISTIC_ACTION_ACT_ACTIVY_CARD = 'actActivyCard'; // 活动card
global.STATISTIC_ACTION_ACT_RESERVE_CARD = 'actReserveCard'; // 预约card
global.STATISTIC_ACTION_ACT_RESERVE_BUTTON = 'actReserveButton'; // 预约按钮
// 排行
global.STATISTIC_ACTION_RANK_CARD = 'rankCard'; // 排行card转化
// global.STATISTIC_ACTION_RANK_BUTTON = 'rankButton' // 排行按钮

global.STATISTIC_ACTION_REWARD_ITEM_CLICK = 'rewardItemClick'; // 领币页单条点击
global.STATISTIC_ACTION_REWARD_ITEM_CARD_CLICK = 'rewardItemCardClick'; // 领币页CARD单条点击
global.STATISTIC_ACTION_REWARD_BANNER_CLICK = 'rewardBannerClick'; // 领币页广告点击

global.STATISTIC_ACTION_BALL_OPEN_CLICK = 'ball_open'; // 打开悬浮球
global.STATISTIC_ACTION_BALL_GAME_CLICK = 'ball_game_click'; // 点击悬浮球游戏标签
global.STATISTIC_ACTION_BALL_GAME_RECENTPLAY_CLICK = 'ball_game_recebtplay_click'; // 悬浮球游戏标签页最近玩
global.STATISTIC_ACTION_BALL_GAME_RECOMMEND_CLICK = 'ball_game_recommend_click'; // 悬浮球游戏推荐二维
global.STATISTIC_ACTION_BALL_COUPON_CLICK = 'ball_coupon_click'; // 点击礼包
global.STATISTIC_ACTION_BALL_MSG_CLICK = 'ball_msg_click'; // 点击消息
global.STATISTIC_ACTION_BALL_ACT_PAGE = 'ball_act_page'; // 活动页面
global.STATISTIC_ACTION_BALL_ACT_CLICK = 'ball_act_click'; // 点击活动
global.STATISTIC_ACTION_BALL_ACT_ITEM_CLICK = 'ball_act_item_click'; // 点击活动条目
global.STATISTIC_ACTION_BALL_CLOSE_CLICK = 'ball_close_click'; // 点击关闭
global.STATISTIC_ACTION_BALL_MASK_CLICK = 'ball_mask_click'; // 点击阴影部分关闭
global.STATISTIC_ACTION_BALL_PLATFORM_CLICK = 'ball_platform_click'; // 点击平台
global.STATISTIC_ACTION_BALL_GOBACK_CLICK = 'ball_goback_click'; // 返回上一页
global.STATISTIC_ACTION_BALL_SERVICE_CLICK = 'ball_service_click'; // 点击客服

global.STATISTIC_ACTION_BALL_APP_OPEN_CLICK = 'app_ball_open'; // 打开悬浮球
global.STATISTIC_ACTION_BALL_APP_COUPON_CLICK = 'app_ball_coupon_click'; // 点击礼包
global.STATISTIC_ACTION_BALL_APP_MSG_CLICK = 'app_ball_msg_click'; // 点击消息
global.STATISTIC_ACTION_BALL_APP_ACT_CLICK = 'app_ball_act_click'; // 点击活动
global.STATISTIC_ACTION_BALL_APP_ACT_ITEM_CLICK = 'app_ball_act_item_click'; // 点击活动条目
global.STATISTIC_ACTION_BALL_APP_CLOSE_CLICK = 'app_ball_close_click'; // 点击关闭
global.STATISTIC_ACTION_BALL_APP_MASK_CLICK = 'app_ball_mask_click'; // 点击阴影部分关闭
global.STATISTIC_ACTION_BALL_APP_PLATFORM_CLICK = 'app_ball_platform_click'; // 点击平台

global.STATISTIC_ACTION_QUIT_GOBACK_CLICK = 'quit_goback_click'; // 退弹点击返回
global.STATISTIC_ACTION_QUIT_ADD_DESK_CLICK = 'quit_add_desk_click'; // 退弹添加至桌面
global.STATISTIC_ACTION_QUIT_CLICK_AD_CLICK = 'quit_click_ad_click'; // 退弹点击广告
global.STATISTIC_ACTION_QUIT_SELECT_SEL_CLICK = 'quit_select_sel_click'; // 退弹设定不再显示
global.STATISTIC_ACTION_QUIT_CANCEL_SEL_CLICK = 'quit_cancel_sel_click'; // 退弹设定显示
global.STATISTIC_ACTION_QUIT_SHORT_CUT_CLICK = 'quit_short_cut_click'; // 退弹创建桌面快捷

global.STATISTIC_ACTION_GAMECENTER_INDEX_ADD_DESK = 'game_center_index_add_desk'; // 从首页将游戏中心添加到桌面
global.STATISTIC_ACTION_GAMECENTER_MINE_ADD_DESK = 'game_center_mine_add_desk'; // 从我的页面将游戏中心添加到桌面
global.STATISTIC_ACTION_GAMECENTER_ADD_DESK = 'game_center_add_desk'; // 将游戏中心添加到桌面
// 搜索页
global.STATISTIC_ACTION_SEARCH_CARD = 'searchCard'; // 搜索card转化
global.STATISTIC_ACTION_SEARCH = 'search_click'; // 搜索点击
global.STATISTIC_ACTION_BALL_APP_SERVICE_CLICK = 'app_ball_service_click'; // 点击客服

global.STATISTIC_ACTION_CP_USER_CREATE_SHORTCUT_CLICK = 'cp_user_create_shortcut'; // CP创建快捷方式
global.STATISTIC_ACTION_CP_USER_SHARE_CLICK = 'cp_user_share_click'; // cp分享

// 积分相关
global.STATISTIC_ACTION_CHECKIN_TAB = 'ball_checkin_tab';
global.STATISTIC_ACTION_CHECKIN_AD = 'checkin_ad';
global.STATISTIC_ACTION_CHECKIN_CONTINUEBUTTON_AWARD = 'checkin_award';
global.STATISTIC_MINE_CHECKIN_GIFT = 'mine_checkin_gift'; // 我的-签到
global.STATISTIC_CHECKIN_SCORE_LOG = 'checkin_score_log'; // 积分日志
global.STATISTIC_CHECKIN_AD_ICON = 'checkin_ad_icon'; // 签到页广告点击
global.STATISTIC_CHECKIN_ACT = 'checkin_act'; // 签到页更多跳转活动页

global.STATISTIC_ACTION_CLICK_INDEX_ICON = 'index_icon_pop'; // 首页悬浮广告点击
global.STATISTIC_ACTION_SHOW_INDEX_ICON = 'index_icon_pop_show'; // 首页悬浮广告展示
global.STATISTIC_ACTION_CLICK_CLOSE_INDEX_ICON = 'index_close_icon'; // 首页关闭悬浮广告
global.STATISTIC_ACTION_CLICK_CLOSE_HOME_AD_POP = 'home_ad_pop_close'; // 首页关闭弹框广告
global.STATISTIC_ACTION_CLICK_JUMP_HOME_AD_POP = 'home_ad_pop_jump'; // 首页弹框广告点击
global.STATISTIC_MSG_ACT_CLICK = 'msg_act_click'; // 消息详情点击活动跳转
global.STATISTIC_MSG_DETAIL_CLICK = 'msg_detail_click'; // 消息详情点击

global.STATISTIC_DETAIL_PAGE_DETAIL_CLICK = 'detail_page_detail_click'; // 详情页详情点击
global.STATISTIC_DETAIL_PAGE_WELFARE_CLICK = 'detail_page_welfare_click'; // 详情页福利点击
global.STATISTIC_DETAIL_PAGE_VIDEO_CLICK = 'detail_page_video_click'; // 详情页视频点击

global.STATISTIC_INDEX_PAGE_WELFARE_MORE_CLICK = 'index_page_welfare_more_click'; // 首页福利专区更多
// 积分商城
global.STATISTIC_MINE_MALL_CLICK = 'mine_mall_click'; // 我的-商城
global.STATISTIC_INDEX_MALL_LEFT_CLICK = 'index_mall_left_click'; // 首页-商城左侧
global.STATISTIC_INDEX_MALL_RIGHT_CLICK = 'index_mall_right_click'; // 首页-商城右侧
global.STATISTIC_INDEX_MALL_LEFT_AND_RIGHT_CLICK = 'index_mall_left_and_right_click'; // 首页-商城左右侧总点击
global.STATISTIC_INDEX_MALL_MORE_CLICK = 'index_mall_more_click'; // 首页-商城更多

global.TENCENT_CAPTCHA_GIFT_APPID = '2023961974'; // 礼包策略防刷
global.STATISTIC_GRADE_PAGE_ACT = 'grades_page_act'; // 等级页面活动埋点
global.STATISTIC_MINE_CLICK = 'mine_click_'; // 我的页面埋点

global.STATISTIC_NEW_GAME_IMG_CLICK = 'new_game_act_img_click'; // 新游来了埋点
global.STATISTIC_MY_GAME_MORE_RECENT = 'my_game_more_recent'; // 我玩过的游戏更多
global.STATISTIC_MY_GAME_INTEREST = 'my_game_interest_game'; // 我玩过的游戏推荐感兴趣的
global.STATISTIC_MY_GAME_TO_INDEX = 'my_game_to_index'; // 我玩过的游戏底部跳转首页
global.STATISTIC_MY_RECENT_GAMES = 'my_recent_games'; // 我最近玩过的游戏
global.STATISTIC_GIFT_CENTER_BOTTOM_MORE = 'gift_center_bottom_more'; // 福利专区底部查看更多

global.STATISTIC_CHECKIN_AD_CLICK = 'checkin_ad_click'; // 签到页广告跳转
global.STATISTIC_FAB_TASK_MORE = 'fab_task_more'; // 任务更多

// 新消息相关
global.STATISTIC_NEW_MSG_SHOW = 'h5_new_push_msg_show'; // 新消息push展示量
global.STATISTIC_NEW_MSG_CLICK = 'h5_new_push_msg_click'; // 新消息push点击量

global.STATISTIC_MY_GAME_INTEREST_GAME_CLICK = 'my_game_interest_game_click'; // 我玩过的游戏图片点击
global.STATISTIC_PAY_GRADE_SHOW = 'pay_grade_show'; // 支付页等级按钮点击
global.STATISTIC_PAY_GRADE_CLICK = 'pay_grade_click'; // 支付页等级按钮点击

global.STATISTIC_REALNAME_POP_SHOW = 'realname_pop_show'; // 实名制弹窗
global.STATISTIC_REALNAME_POP_BUTTON_CLICK = 'realname_pop_button_click'; // 实名制弹窗点击
global.STATISTIC_REALNAME_POP_CLICK_RETURN = 'realname_pop_click_return'; // 实名制点击返回
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v2_static_js_statistic__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_client__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_client_platform__ = __webpack_require__(219);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 648));
    }
  }, {
    path: '/demo',
    name: 'demo',
    component: function component() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 631));
    }
  }, {
    path: '/Monitor',
    name: 'monitor',
    component: function component() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 632));
    }
  }, {
    path: '/testexit',
    name: 'testExit',
    component: function component() {
      return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, 634));
    }
  }, {
    path: '/test',
    name: 'test',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 633));
    }
  }, {
    path: '/column/:type', // type 1同名改编 2新游
    name: 'Column',
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 647));
    }
  }, {
    path: '/mine',
    name: 'Mine',
    component: function component() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 669));
    }
  }, {
    path: '/user/recent',
    name: 'RecentGame',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 673));
    }
  }, {
    path: '/user/consumeLog',
    name: 'UserConsumeLog',
    component: function component() {
      return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 660));
    }
  }, {
    path: '/user/giftLog',
    name: 'UserGiftLog',
    component: function component() {
      return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 667));
    }
  }, {
    path: '/user/giftList',
    name: 'UserGiftList',
    component: function component() {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 666));
    }
  }, {
    path: '/user/messages',
    name: 'UserMessage',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 671));
    }
  }, {
    path: '/user/message/:id',
    name: 'UserMessageDetail',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 672));
    }
  }, {
    path: '/user/notice/:id',
    name: 'UserNoticeDetail',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 674));
    }
  }, {
    path: '/user/coupon',
    name: 'UserCouponList',
    component: function component() {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 662));
    }
  }, {
    path: '/user/info',
    name: 'UserInfo',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 670));
    }
  },
  // {
  //   path: '/grade',
  //   name: 'Grade',
  //   component: () => import('@v2/components/user/Level')
  // },
  {
    path: '/user/feedbackType',
    name: 'UserFeedbackType',
    component: function component() {
      return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 665));
    }
  }, {
    path: '/user/feedback/:type',
    name: 'UserFeedback',
    component: function component() {
      return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 664));
    }
  }, {
    path: '/user/couponHistory/:type',
    name: 'UserCouponHistory',
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 661));
    }
  }, {
    path: '/detail/:gameId',
    name: 'Detail',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 635));
    }
  }, {
    path: '/rank/',
    name: 'Rank',
    component: function component() {
      return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 656));
    }
  }, {
    path: '/category/',
    name: 'Category',
    component: function component() {
      return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 583));
    }
  }, {
    path: '/error/',
    name: 'Error',
    component: function component() {
      return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 636));
    }
  }, {
    path: '/activity/:type',
    name: 'Activity',
    component: function component() {
      return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 581));
    }
  }, {
    path: '/fab/:gameId',
    name: 'Fab',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 638));
    }
  }, {
    path: '/pay',
    name: 'pay',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 653));
    }
  }, {
    path: '/pay/couponSel',
    name: 'couponSel',
    component: function component() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 652));
    }
  }, {
    path: '/user/cardPurchaseList/:sno',
    name: 'UserCardPurchaseList',
    component: function component() {
      return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, 659));
    }
  }, {
    path: '/gift/index',
    name: 'gift',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 284));
    } // todo 准删除页面，临时修改跳转至礼包中心
  }, {
    path: '/gift/center',
    name: 'giftCenter',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 284));
    }
  }, {
    path: '/reward',
    name: 'reward',
    component: function component() {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 657));
    }
  }, {
    path: '/balls/:gameId/:ballType',
    name: 'balls',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 582));
    }
  }, {
    path: '/search',
    name: 'search',
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 658));
    }
  }, {
    path: '/favtip/:gameId',
    name: 'favtip',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 645));
    }
  }, {
    path: '/GameCenterShortCut',
    name: 'GameCenterShortCut',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 644));
    }
  }, {
    path: '/xfq/:gameId',
    name: 'xfq',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 676));
    }
  }, {
    path: '/question/:roleId/:serverId/:userId/:questionId/:platformId',
    name: 'question',
    component: function component() {
      return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 655));
    }
  }, {
    path: '/scoreLog',
    name: 'scoreLog',
    component: function component() {
      return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 640));
    }
  }, {
    path: '/scoreFaq',
    name: 'scoreFaq',
    component: function component() {
      return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 639));
    }
  }, {
    path: '/giftFaq',
    name: 'giftFaq',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 643));
    }
  }, {
    path: '/mineGame',
    name: 'mineGame',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 675));
    }
  }, {
    path: '/mall',
    name: 'mallIndex',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 650));
    }
  }, {
    path: '/mallHistory',
    name: 'mallHistory',
    component: function component() {
      return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 649));
    }
  }, {
    path: '/mallSecKill',
    name: 'mallSecKill',
    component: function component() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 651));
    }
  }, {
    path: '/gradeFaq',
    name: 'gradeFaq',
    component: function component() {
      return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 668));
    }
  }, {
    path: '/transfer/:url',
    name: 'transfer',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 642));
    }
  }, {
    path: '/gift/exchange',
    name: 'exchange',
    component: function component() {
      return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 646));
    }
  }, {
    path: '/user/download',
    name: 'download',
    component: function component() {
      return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 663));
    }
  }]
});

router.beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_3__static_client__["a" /* default */].clientSdk) {
    __WEBPACK_IMPORTED_MODULE_3__static_client__["a" /* default */].setTitleBarShowState(true, false);
    if (__WEBPACK_IMPORTED_MODULE_4__static_client_platform__["a" /* default */].isQd()) {
      // 处理起点侧回退
      history.replaceState({ key: '00000.000' }, true);
      __WEBPACK_IMPORTED_MODULE_3__static_client__["a" /* default */].clientSdk.inGame(true);
    }
    next();
  } else {
    console.log('sdk初始化');
    __WEBPACK_IMPORTED_MODULE_3__static_client__["a" /* default */].init(function () {
      next();
    });
  }
});

router.afterEach(function (route) {
  var url = window.location.origin + '/#' + route.fullPath;
  __WEBPACK_IMPORTED_MODULE_2__v2_static_js_statistic__["a" /* default */].addRecord(global.STATISTIC_ACTION_ACCESS, '', url);
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
// /**
//  * vue全局组件
//  */



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('news-list-modal', function () {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 617));
}); // 新闻列表
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('confirm-no-button-modal', function () {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 596));
}); // 确认无按钮弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('confirm-ad-modal', function () {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 593));
}); // 确认无按钮弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('check-in', function () {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 637));
}); // 签到弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('confirm-cancel-modal', function () {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 594));
}); // 通用提示,确认取消弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('fab-game-modal', function () {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 600));
}); // 悬浮球游戏标签
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('confirm-cancel-center-modal', function () {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 595));
}); // 居中显示弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('mall-modal', function () {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 609));
}); // 积分兑换弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('goods-detail-modal', function () {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 604));
}); // 积分兑换弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('mall-address-modal', function () {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 608));
}); // 积分兑换地址弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('toast-modal', function () {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 627));
}); // toast弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('level-tips-modal', function () {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 607));
}); // toast弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('push-msg-modal', function () {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 623));
}); // push消息弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('fab-task-modal', function () {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 641));
}); // 签到fabtask页面
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('message-left-modal', function () {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 612));
}); // 左对齐消息弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('message-heng-modal', function () {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 611));
}); // 横线消息弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('message-zong-modal', function () {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 615));
}); // 纵向消息弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('open-h5-game', function () {
  return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 620));
}); // H5游戏打开即玩
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('donwload-status', function () {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 599));
}); // 下载状态按钮
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('donwload-rights', function () {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 598));
}); // 下载权限信息弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('coupon-modal', function () {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 597));
}); // 天降赠券弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('notice-modal', function () {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 619));
}); // 红点弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('promt-select-modal', function () {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 622));
}); // 提示弹窗，选择按钮
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('gift-modal', function () {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 603));
}); // 礼包弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('quit-modal', function () {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 624));
}); // 游戏退出弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ball-gift-modal', function () {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 590));
}); // 礼包悬浮球弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('gift-content-modal', function () {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 601));
}); // 礼包弹窗(fanhui)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('mine-modal', function () {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 616));
}); // 我的弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('gift-list-modal', function () {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 602));
}); // 礼包列表弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-gift-list-modal', function () {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 586));
}); // app礼包列表弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('act-list-modal', function () {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 584));
}); // 活动列表弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-act-list-modal', function () {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 585));
}); // App活动列表弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('message-modal', function () {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 614));
}); // 消息内容弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('message-full-text-modal', function () {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 610));
}); // 富文本消息内容
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-message-full-text-modal', function () {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 587));
}); // App富文本消息内容
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('qz-message-modal', function () {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 625));
}); // 强制消息内容弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('message-list-modal', function () {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 613));
}); // 消息列表弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-message-list-modal', function () {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 588));
}); // App消息列表弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('identity-modal', function () {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 606));
}); // 身份证录入弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('identity-confirm-modal', function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 243));
}); // 身份证录入确认弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('smscode-modal', function () {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 626));
}); // 身份证录入弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('confirm-modal', function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 242));
}); // 通用提示,确认弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('bottom-show', function () {
  return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 591));
}); // 底部导航栏
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('card-detail-modal', function () {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 592));
}); // 储值卡详情弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('confirm-blue', function () {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 654));
}); // 蓝色确认弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pop-notice-modal', function () {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 621));
}); // 公告弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('notice-content-modal', function () {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 618));
}); // H5悬浮球公告内容
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-notice-content-modal', function () {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 589));
}); // APP悬浮球公告内容
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('home-ad-pop-modal', function () {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 605));
}); // 首页弹框广告
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('txt-tips-modal', function () {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 628));
}); // 文字提示弹框
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('popup-msg-modal', function () {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 629));
}); // 弹框消息模版
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vip-msg', function () {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 630));
}); // VIP升级提示

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__initStyle__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__);
/**
 * 全局指令
 */





// 翻页指令
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('init-page-height', {
  componentUpdated: function componentUpdated(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].initPageHeight(el);
  },
  inserted: function inserted(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].initPageHeight(el);
  }
});
// 初始化list宽度
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('list-width-init', {
  componentUpdated: function componentUpdated(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].listWidthInit(el);
  },
  inserted: function inserted(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].listWidthInit(el);
  }
});
// 显示隐藏弹窗
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('modal-show', {
  componentUpdated: function componentUpdated(el, binding) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].modalShow(el, binding);
  },
  inserted: function inserted(el, binding) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].modalShow(el, binding);
  },
  unbind: function unbind(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].modalHide(el);
  }
});
// 显示隐藏toast
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('toast-show', {
  componentUpdated: function componentUpdated(el, binding) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].toastShow(el, binding);
  },
  inserted: function inserted(el, binding) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].toastShow(el, binding);
  },
  unbind: function unbind(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].toastHide(el);
  }
});
// 容器文字过长显示省略号
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('text-clip-init', {
  componentUpdated: function componentUpdated(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].textClipInit(el);
  },
  inserted: function inserted(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].textClipInit(el);
  }
});
// 容器文字过长保留空白
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('text-clip-init-pre', {
  componentUpdated: function componentUpdated(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].textClipInitPre(el);
  },
  inserted: function inserted(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].textClipInitPre(el);
  }
});

// 首页最近初始化宽度
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('width-init-user-game', {
  componentUpdated: function componentUpdated(el, binding) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].widthInitUserGame(el, binding);
  },
  inserted: function inserted(el, binding) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].widthInitUserGame(el, binding);
  }
});
// 首页预约初始化宽度
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('width-init-reserve', {
  componentUpdated: function componentUpdated(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].widthInitReserve(el);
  },
  inserted: function inserted(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].widthInitReserve(el);
  }
});
// 用户中心最近玩过初始化宽度
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('width-init-user-recent', {
  componentUpdated: function componentUpdated(el) {
    __WEBPACK_IMPORTED_MODULE_1__initStyle__["a" /* default */].widthInitUserRecent(el);
  }
});
// 自动获取焦点指令
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el, value) {
    if (value) {
      el.focus();
    }
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__statistic__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonMethods__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mta_h5_analysis__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mta_h5_analysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mta_h5_analysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__v2_static_client_style__ = __webpack_require__(233);
/**
 * Vue全局应用
 */









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.MtaH5 = __WEBPACK_IMPORTED_MODULE_3_mta_h5_analysis___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.addRecord = __WEBPACK_IMPORTED_MODULE_1__statistic__["a" /* default */].addRecord;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.addMtaEvent = __WEBPACK_IMPORTED_MODULE_1__statistic__["a" /* default */].addMtaEvent;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.pushH5Msg = __WEBPACK_IMPORTED_MODULE_2__commonMethods__["a" /* default */].pushH5Msg;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$modal = __WEBPACK_IMPORTED_MODULE_5__modal__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$style = __WEBPACK_IMPORTED_MODULE_6__v2_static_client_style__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$platformId = global.PLATFORMID;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
  __webpack_require__(379)
  __webpack_require__(381)
  __webpack_require__(378)
  __webpack_require__(383)
  __webpack_require__(380)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(500),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v2_config_client__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v2_static_client_style__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v2_static_client_platform__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__v2_static_js_commonUtil_js__ = __webpack_require__(263);







var client = {
  clientSdk: undefined,
  init: function init(callback) {
    global.PLATFORMID = __WEBPACK_IMPORTED_MODULE_3__v2_static_client_platform__["a" /* default */].getPlatformId();
    global.WEB_HOST_HTTP = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].httpsHost[global.PLATFORMID];
    global.API_HOST = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].apiHost[global.PLATFORMID];
    global.LY_API_HOST = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].lyApiHost[global.PLATFORMID];
    if (__WEBPACK_IMPORTED_MODULE_3__v2_static_client_platform__["a" /* default */].isAndroid()) {
      global.APP_HOST = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].appHost[global.PLATFORMID];
    }
    global.NEW_APP_HOST = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].newAppHosts[global.PLATFORMID];
    global.NEW_GAME_HOST = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].newGameHosts[global.PLATFORMID];
    global.NEW_GAME_NO_SCE_HOST = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].newGameNoSceHosts[global.PLATFORMID];
    global.APP_NAME = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].appName[global.PLATFORMID];
    global.COIN_NAME = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].coinName[global.PLATFORMID];
    global.MTA_SID = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].mtaSid[global.PLATFORMID];
    global.MTA_CID = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].mtaCid[global.PLATFORMID];
    global.MTA_HID = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].mtaHid[global.PLATFORMID];
    __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$platform = __WEBPACK_IMPORTED_MODULE_3__v2_static_client_platform__["a" /* default */];
    __WEBPACK_IMPORTED_MODULE_2__v2_static_client_style__["a" /* default */].init();
    this.loadClientJs(callback);
  },
  login: function login(callback) {
    if (__WEBPACK_IMPORTED_MODULE_3__v2_static_client_platform__["a" /* default */].isQd()) {
      // 起点登录
      client.clientSdk.login(function (result) {
        if (result.result === 0 && result.code === 0) {
          callback();
        }
      });
    } else {
      if (callback) {
        window.loginSuccess = function (ywguid, ywkey) {
          callback(ywguid, ywkey);
        };
      }
      client.clientSdk.loginByQQread(function (result) {
        console.log('测试哈哈哈：');
        var res = JSON.parse(result);
        console.log(res);
        callback(res.data.ywguid, res.data.ywkey);
      });
    }
  },
  qlogin: function qlogin(callback) {
    if (global.PLATFORMID === '1') {
      client.clientSdk.qlogin(function () {
        callback();
      });
    } else if (global.PLATFORMID === '2') {
      if (callback) {
        window.loginSuccess = function (ywguid, ywkey) {
          callback(ywguid, ywkey);
        };
      }
      client.clientSdk.loginByQQread();
    } else if (global.PLATFORMID === '3') {
      client.clientSdk.login(function () {
        callback();
      });
    }
  },
  goBack: function goBack() {
    if (global.PLATFORMID === '1') {
      client.clientSdk.goBack();
    } else if (global.PLATFORMID === '2') {
      client.clientSdk.goqqread();
    } else if (global.PLATFORMID === '3') {
      var fabGamePlayNum = __WEBPACK_IMPORTED_MODULE_5__v2_static_js_commonUtil_js__["a" /* default */].getCookie('fabQDGamePlayNum');
      if (fabGamePlayNum !== null && fabGamePlayNum > 0) {
        __WEBPACK_IMPORTED_MODULE_5__v2_static_js_commonUtil_js__["a" /* default */].setCookie('fabQDGamePlayNum', fabGamePlayNum - 1);
        client.clientSdk.exit();
      } else {
        __WEBPACK_IMPORTED_MODULE_5__v2_static_js_commonUtil_js__["a" /* default */].setCookie('fabQDGamePlayNum', 0);
        client.clientSdk.goBack();
      }
    }
  },
  setTitleBarShowState: function setTitleBarShowState(isShowBar, isShowIcon) {
    if (__WEBPACK_IMPORTED_MODULE_3__v2_static_client_platform__["a" /* default */].isQq()) {
      isShowBar = isShowBar.toString();
      isShowIcon = isShowIcon.toString();
      client.clientSdk.setBackKeyCallback('');
    }
    client.clientSdk.setTitleBarShowState(isShowBar, isShowIcon);
  },
  getVersion: function getVersion(callback, failCallback) {
    if (global.PLATFORMID === '1') {
      client.clientSdk.getVersion(function (version) {
        if (version.data.versionCode >= 341) {
          callback(version);
        } else {
          if (failCallback !== undefined) {
            failCallback(version);
          } else {
            alert('请先升级版本');
          }
        }
      });
    } else if (global.PLATFORMID === '2') {
      client.clientSdk.getvision(function (version) {
        if (version >= 662) {
          callback(version);
        } else {
          if (failCallback !== undefined) {
            failCallback(version);
          } else {
            alert('请先升级版本');
          }
        }
      });
    }
  },
  setBackKeyCallback: function setBackKeyCallback(method) {
    if (global.PLATFORMID === '2') {
      client.clientSdk.setBackKeyCallback(method);
    }
  },
  loadClientJs: function loadClientJs(callback) {
    console.log('sdk加载');
    var jsUrls = __WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].clientJsUrls[global.PLATFORMID];
    client.loadJs(jsUrls[0]).then(function () {
      client.loadJs(jsUrls[1]).then(function () {
        client.loadJs(jsUrls[2]).then(function () {
          client.clientSdk = window[__WEBPACK_IMPORTED_MODULE_1__v2_config_client__["a" /* default */].sdkName[global.PLATFORMID]];
          callback();
        });
      });
    });
  },
  loadJs: function loadJs(url) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript';
      document.body.appendChild(script);

      script.onload = function () {
        console.log(url + '加载完成');
        resolve();
      };

      script.onerror = function () {
        reject();
      };
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (client);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  checkIsNum: function checkIsNum(num) {
    var reg = /^[1-9]{1}[0-9]*$/;
    return reg.test(num);
  },
  checkIsPhone: function checkIsPhone(phone) {
    var reg = /^1[0123456789]\d{9}$/;
    return reg.test(phone);
  },
  checkInternationalPhone: function checkInternationalPhone(phone) {
    // 检查国际手机号是否符合规则
    var reg = /^[0123456789]\d{3,12}$/;
    return reg.test(phone);
  },
  checkCityCode: function checkCityCode(cityCode) {
    // 检查国际手机区号是否符合规则
    var reg = /^\+?[0123456789]\d{1,7}$/;
    return reg.test(cityCode);
  },
  checkIsEmail: function checkIsEmail(email) {
    var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    return reg.test(email);
  },
  checkIsVcode: function checkIsVcode(num) {
    var reg = /^[0-9]{6}$/;
    return reg.test(num);
  },
  getUrlParam: function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  setCookie: function setCookie(name, value, expires, path, domain, secure) {
    var exp = new Date();
    exp.setTime(exp.getTime() + expires * 1000); // 过期时间2分钟
    document.cookie = name + '=' + escape(value) + (exp == null ? '' : '; expires=' + exp.toGMTString()) + (path == null ? '' : '; path=' + path) + (domain == null ? '' : '; domain=' + domain) + (secure === true ? '; secure' : '');
  },
  getCookie: function getCookie(name) {
    var arg = name + '=';
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;
    while (i < clen) {
      var j = i + alen;
      if (document.cookie.substring(i, j) === arg) {
        return this.getCookieVal(j);
      }
      i = document.cookie.indexOf(' ', i) + 1;
      if (i === 0) break;
    }
    return null;
  },
  getCookieVal: function getCookieVal(offset) {
    var endstr = document.cookie.indexOf(';', offset);
    if (endstr === -1 || endstr === '-1') {
      endstr = document.cookie.length;
    }
    return unescape(document.cookie.substring(offset, endstr));
  },
  formatLabelHtml: function formatLabelHtml(goods) {
    if (goods.saleQuantity - goods.total >= 0) {
      return '<span class="df_state BG_d T_12_14 T_w">缺货</span>';
    } else {
      switch (parseInt(goods.label)) {
        case 0:
          return '';
        case 1:
          return '<span class="df_state BG_r T_12_14 T_w">热卖</span>';
        case 2:
          return '<span class="df_state BG_b T_12_14 T_w">限购</span>';
        case 3:
          return '<span class="df_state BG_y T_12_14 T_w">独家</span>';
        case 4:
          return '<span class="df_state BG_g T_12_14 T_w">新品</span>';
      }
    }
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v2_router__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_global__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__v2_static_js_globalProto__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__v2_static_js_component__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__v2_static_js_directive__ = __webpack_require__(252);









__WEBPACK_IMPORTED_MODULE_3_es6_promise___default.a.polyfill();
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  data: {
    birthday: '2017-08-24'
  },
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_1__v2_router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_0__App___default.a);
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a);

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  // 推送h5消息
  pushH5Msg: function pushH5Msg(platformId) {
    var apiUrl = global.API_HOST + 'qqread/message/returnPlayerMsg?platformId=' + platformId;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUrl).then(function (response) {
      if (response.data.code !== 0) {
        console.log(response.data.msg);
      }
    }).catch(function (error) {
      console.log(error);
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  textClipInit: function textClipInit(el) {
    el.style['text-overflow'] = 'ellipsis';
    el.style['overflow'] = 'hidden';
    el.style['white-space'] = 'nowrap';
  },
  textClipInitPre: function textClipInitPre(el) {
    el.style['text-overflow'] = 'ellipsis';
    el.style['overflow'] = 'hidden';
    el.style['white-space'] = 'pre';
  },
  widthInitUserGame: function widthInitUserGame(el, binding) {
    if (binding.value > 0) {
      var containerWidth = el.clientWidth;
      var padding = 96;
      var listWidth = binding.value * 48 + (binding.value - 1) * 6;
      var itemWidth = containerWidth - padding - listWidth;
      var item = document.getElementsByClassName('pir_main')[0];
      if (item !== undefined) {
        item.style.width = itemWidth + 'px';
      }
    }
  },
  widthInitReserve: function widthInitReserve(el) {
    var containerWidth = el.clientWidth;
    var padding = 28 + 24 + 6 + 8 + window.innerWidth * 0.3;
    var titleWidth = document.getElementsByClassName('dm_name')[0].clientWidth;
    var itemWidth = containerWidth - padding - titleWidth;
    var itemCurrentWidth = document.getElementsByClassName('dm_gname')[0].clientWidth;
    if (itemCurrentWidth > itemWidth) {
      document.getElementsByClassName('dm_gname')[0].style.width = itemWidth + 'px';
    }
  },
  widthInitUserRecent: function widthInitUserRecent(el) {
    var containerWidth = el.clientWidth;
    var padding = 28 + 24 + 6 + 8 + window.innerWidth * 0.3;
    var titleWidth = document.getElementsByClassName('userRecentTitle')[0].clientWidth + 30;
    var itemWidth = containerWidth - padding - titleWidth;
    var itemCurrentWidth = document.getElementsByClassName('userRecent')[0] ? document.getElementsByClassName('userRecent')[0].clientWidth : 0;
    if (itemCurrentWidth > itemWidth) {
      document.getElementsByClassName('userRecent')[0].style.width = itemWidth + 'px';
    }
  },
  removePx: function removePx(str) {
    return str.slice(0, str.indexOf('px'));
  },
  initPageHeight: function initPageHeight(el) {
    var contentHeight = document.getElementsByClassName('p_cont')[0].offsetHeight;
    var windowHeight = window.innerHeight;
    if (contentHeight < windowHeight) {
      el.style.height = windowHeight + 'px';
    } else {
      el.style.height = 'auto';
    }
  },
  listWidthInit: function listWidthInit(el) {
    if (el.childNodes.length > 0) {
      var itemNum = 0;
      var items = el.childNodes;
      for (var i = 0; i < items.length; i++) {
        if (items[i].childNodes.length > 0) {
          items[i].style.display = 'list-item';
          itemNum++;
        }
      }

      var item = el.childNodes[0];
      var style = item.currentStyle || window.getComputedStyle(item);
      var marginLeftStr = style['margin-left'];
      var marginRightStr = style['margin-right'];
      var marginLeft = Math.ceil(marginLeftStr.slice(0, marginLeftStr.indexOf('px')));
      var marginRight = Math.ceil(marginRightStr.slice(0, marginRightStr.indexOf('px')));
      var outerWidth = item.offsetWidth + marginLeft + marginRight;

      el.style.width = (outerWidth + 1) * itemNum + 'px';
    }
  },
  modalShow: function modalShow(el, binding) {
    var mask = el.childNodes[0];
    var wrap = el.childNodes[2];

    if (binding.value === true) {
      mask.style.display = 'block';
      document.body.style.top = '-' + document.body.scrollTop + 'px';
      if (document.body.className.indexOf('M_open') === -1) {
        document.body.className += ' M_open';
      }
      wrap.style.display = 'block';
      var marginTop = window.getComputedStyle(wrap).getPropertyValue('margin-top').replace('px', '');
      marginTop = marginTop === 'undefined' ? 0 : marginTop;
      var marginBottom = window.getComputedStyle(wrap).getPropertyValue('margin-bottom').replace('px', '');
      marginBottom = marginBottom === 'undefined' ? 0 : marginBottom;
      console.log('调试高度：');
      console.log(window.outerHeight);
      console.log(wrap.offsetHeight);
      console.log(marginTop);
      console.log(marginBottom);
      wrap.style.top = (window.outerHeight - wrap.offsetHeight - marginTop - marginBottom) / 2 + 'px';
    }
  },
  modalHide: function modalHide(el) {
    var mask = el.childNodes[0];
    var wrap = el.childNodes[2];
    var top = parseInt(document.body.style.top.replace('-', '').replace('px', ''));
    document.body.className = document.body.className.replace(/ M_open/g, '');
    mask.style.display = 'none';
    wrap.style.display = 'none';
    window.scroll(0, top);
  },
  toastShow: function toastShow(el, binding) {
    var wrap = el.childNodes[2];
    if (binding.value === true) {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      document.body.style.top = '-' + scrollTop + 'px';
      if (document.body.className.indexOf('T_open') === -1) {
        document.body.className += ' T_open';
      }
      wrap.style.display = 'block';
      wrap.style.top = (window.innerHeight - wrap.offsetHeight) / 2 + 'px';
    }
  },
  toastHide: function toastHide(el) {
    var wrap = el.childNodes[2];
    var top = parseInt(document.body.style.top.replace('-', '').replace('px', ''));
    document.body.className = document.body.className.replace(/ T_open/g, '');
    wrap.style.display = 'none';
    window.scroll(0, top);
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v2_components_common_ConfirmModal__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v2_components_common_ConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__v2_components_common_ConfirmModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v2_components_common_RealNameCouponModal__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v2_components_common_RealNameCouponModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__v2_components_common_RealNameCouponModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v2_components_common_IdentityConfirmModal__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v2_components_common_IdentityConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__v2_components_common_IdentityConfirmModal__);





var modal = {
  getModalInstance: function getModalInstance(ModalComponent, props) {
    var instance = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      data: props,
      render: function render(h) {
        return h(ModalComponent, { props: props });
      }
    });
    var component = instance.$mount();
    document.getElementById(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$style.cssClassName).appendChild(component.$el);
    var modal = instance.$children[0];
    return modal;
  },
  showIdentityModal: function showIdentityModal(confirmCallback, closeCallback, syMoney, syOrder) {
    var props = {
      confirmCallback: confirmCallback,
      closeCallback: closeCallback,
      syMoney: syMoney,
      syOrder: syOrder
    };
    var identityModal = modal.getModalInstance(__WEBPACK_IMPORTED_MODULE_3__v2_components_common_IdentityConfirmModal___default.a, props);
    identityModal.show();
  },
  showConfirmModal: function showConfirmModal(content) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var confirmText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var confirmCallback = arguments[3];
    var closeCallback = arguments[4];

    var props = {
      showModal: true,
      content: '<p>' + content + '</p>',
      title: title,
      confirmText: confirmText,
      confirmCallback: confirmCallback,
      closeCallback: closeCallback
    };
    var confirmModal = modal.getModalInstance(__WEBPACK_IMPORTED_MODULE_1__v2_components_common_ConfirmModal___default.a, props);
    confirmModal.show();
  },
  showRealNameCouponModal: function showRealNameCouponModal(content) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var closeCallback = arguments[2];

    var props = {
      showMsgModal: true,
      msgContent: '<p>' + content + '</p>',
      msgTitle: title,
      closeBack: closeCallback
    };
    modal.getModalInstance(__WEBPACK_IMPORTED_MODULE_2__v2_components_common_RealNameCouponModal___default.a, props);
  },
  closeIdentityModal: function closeIdentityModal() {
    var identityClass = document.getElementById('identityClass');
    identityClass.parentNode.removeChild(identityClass);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (modal);

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mta_h5_analysis__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mta_h5_analysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mta_h5_analysis__);
//
//
//
//
//
//


// import Vue from 'vue'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

// Raven
//     .config('https://3d86cb3b7dbc478aaa6a790daaa11a4f@sentry.qidian.com/26')
//     .addPlugin(RavenVue, Vue)
//     .install()
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    // 初始化mta统计代码
    __WEBPACK_IMPORTED_MODULE_0_mta_h5_analysis___default.a.init({
      'sid': global.MTA_SID, // 必填，统计用的appid
      'cid': global.MTA_CID, // 如果开启自定义事件，此项目为必填，否则不填
      'autoReport': 1, // 是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
      'senseHash': 1, // hash锚点是否进入url统计
      'senseQuery': 1, // url参数是否进入url统计
      'performanceMonitor': 1, // 是否开启性能监控
      'ignoreParams': [] // 开启url参数上报时，可忽略部分参数拼接上报
    });

    if (false) {
      import( /* webpackChunkName: "eruda" */'eruda').then(function (eruda) {
        eruda.init();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      display: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    setTimeout(function () {
      _this.display = _this.showModal;
    }, 10);
  },

  props: {
    showModal: {
      type: Boolean,
      required: false
    },
    content: {
      type: String,
      required: true
    },
    confirmText: {
      type: String
    },
    title: {
      type: String
    },
    confirmCallback: {
      type: Function,
      required: false
    },
    closeCallback: {
      type: Function,
      required: false
    }
  },
  computed: {
    modalConfirm: function modalConfirm() {
      if (this.confirmText !== undefined && this.confirmText !== '') {
        return this.confirmText;
      } else {
        return '确认';
      }
    },
    modalTitle: function modalTitle() {
      if (this.title !== undefined && this.title !== '') {
        return this.title;
      } else {
        return '提示';
      }
    }
  },
  methods: {
    show: function show() {
      this.display = true;
    },
    confirm: function confirm() {
      this.display = false;
      this.$emit('confirm');
      if (this.confirmCallback) {
        this.confirmCallback();
      }
    },
    closeModal: function closeModal() {
      this.display = false;
      this.$emit('closeModal');
      if (this.closeCallback) {
        this.closeCallback();
      }
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      display: false,
      cardId: '',
      name: ''
    };
  },

  props: {
    confirmCallback: {
      type: Function,
      required: false
    },
    closeCallback: {
      type: Function,
      required: false
    },
    syMoney: {
      type: Number,
      required: false
    },
    syOrder: {
      type: Number,
      required: false
    }
  },
  created: function created() {
    this.addRecord(global.STATISTIC_REALNAME_POP_SHOW);
    window.addEventListener('resize', function () {
      console.log('111进入');
      setTimeout(function () {
        var _mw = document.getElementsByClassName('M_certification')[0];
        document.body.style.top = '-' + document.body.scrollTop + 'px';
        _mw.style.top = (window.outerHeight - _mw.offsetHeight) / 2 + 'px';
      }, 0);
    });
  },
  mounted: function mounted() {
    var timer = setInterval(function () {
      var wrap = document.getElementsByClassName('M_certification')[0];
      if (typeof wrap !== 'undefined' || (typeof wrap === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(wrap)) !== undefined) {
        clearInterval(timer);
        var pos = (document.documentElement.clientHeight - wrap.clientHeight) / 2 + document.documentElement.scrollTop;
        wrap.style.position = 'absolute';
        wrap.style.top = pos + 'px';
      }
    }, 200);
  },

  methods: {
    show: function show() {
      this.display = true;
    },
    confirm: function confirm() {
      // this.display = false
      if (this.confirmCallback) {
        this.addRecord(global.STATISTIC_REALNAME_POP_BUTTON_CLICK);
        this.confirmCallback(this.cardId, this.name);
      }
    },
    close: function close() {
      this.display = false;
      if (this.closeCallback) {
        this.closeCallback();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showMsgModal: {
      type: Boolean,
      default: false
    },
    msgContent: {
      type: String
    },
    msgTitle: {
      type: String
    },
    closeBack: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      display: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    setTimeout(function () {
      _this.display = _this.showMsgModal;
    }, 10);
  },
  created: function created() {},

  methods: {
    closeModal: function closeModal() {
      this.closeBack();
    }
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-587dd4e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "modal-show",
      rawName: "v-modal-show",
      value: (_vm.display),
      expression: "display"
    }]
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "M_wrap M_notice M_style M_btn_0 M_style_2 M_style_2_h"
  }, [_c('div', {
    staticClass: "M_cont"
  }, [_c('p', {
    staticClass: "M_title T_18_25 T_b"
  }, [_c('span', [_vm._v(_vm._s(_vm.msgTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "T_12_16 T_b",
    domProps: {
      "innerHTML": _vm._s(_vm.msgContent)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "M_close I_n",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    directives: [{
      name: "modal-show",
      rawName: "v-modal-show",
      value: (_vm.display),
      expression: "display"
    }],
    attrs: {
      "id": "identityClass"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('section', {
    staticClass: "M_wrap M_certification M_btn_1 M_top",
    staticStyle: {
      "top": "270px",
      "display": "block"
    }
  }, [_c('p', {
    staticClass: "M_title T_18_25 T_b"
  }, [_vm._v("实名认证")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "M_form"
  }, [_c('div', {
    staticClass: "M_f_item"
  }, [_c('label', {
    staticClass: "T_14_24",
    attrs: {
      "for": ""
    }
  }, [_vm._v("真实姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "M_f_item"
  }, [_c('label', {
    staticClass: "T_14_24",
    attrs: {
      "for": ""
    }
  }, [_vm._v("身份证号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.cardId),
      expression: "cardId",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号码"
    },
    domProps: {
      "value": (_vm.cardId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardId = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "M_f_btns cf"
  }, [_c('a', {
    staticClass: "M_btn T_w M_b_close",
    attrs: {
      "href": "javascript:void(0);",
      "title": "提交认证"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("提交认证")])]), _vm._v(" "), _c('div', {
    staticClass: "M_f_coupon"
  }, [_c('p', {
    staticClass: "M_f_c_amount T_12_16"
  }, [_c('em', [_vm._v("￥"), _c('i', [_vm._v(_vm._s(_vm.syMoney))])]), _vm._v(" "), _c('span', [_vm._v("满￥" + _vm._s(_vm.syOrder) + "使用")])]), _vm._v(" "), _c('p', {
    staticClass: "M_f_c_tip T_12_16"
  }, [_vm._v("实名认证通过送" + _vm._s(_vm.syMoney) + "元代金券")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "M_close I_n",
    on: {
      "click": _vm.close
    }
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "M_cont"
  }, [_c('p', {
    staticClass: "T_12_18 T_w"
  }, [_vm._v("根据国家规定，必须进行实名认证，才可体验游戏服务，为帮助未成年人防沉迷，请填写身份信息认证。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "M_cont"
  }, [_c('p', {
    staticClass: "T_12_14 T_w"
  }, [_vm._v("1、身份信息仅用于实名认证使用，本平台承诺绝不向任何第三方透露。")]), _vm._v(" "), _c('p', {
    staticClass: "T_12_14 T_w"
  }, [_vm._v("2、具体以游戏内活动为准。")]), _vm._v(" "), _c('p', {
    staticClass: "T_12_14 T_w"
  }, [_vm._v("3、如有任何疑问，请咨询阅文客服QQ：800038605")])])
}]}

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    directives: [{
      name: "modal-show",
      rawName: "v-modal-show",
      value: (_vm.display),
      expression: "display"
    }]
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "M_wrap M_info M_btn_1"
  }, [_c('p', {
    staticClass: "M_title T_18_25 T_b"
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "M_cont",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "M_btns cf"
  }, [_c('a', {
    class: 'M_btn T_w ' + _vm.$style.cssBtnColor,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.modalConfirm))])]), _vm._v(" "), _c('a', {
    staticClass: "M_close I_n",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var clientConfig = {
  origin: {
    '1': 'm-game.qidian.com',
    '2': 'm-game.book.qq.com',
    '3': 'p-game.qidian.com'
  },
  sdkName: {
    '1': 'qdnative',
    '2': 'androidqq',
    '3': 'qdnative'
  },
  cssClassName: {
    '1': 'S_QD_A',
    '2': 'S_QQ_A',
    '3': 'S_QD_I'
  },
  cssBtnColor: {
    '1': 'B_r',
    '2': 'B_b',
    '3': 'B_r'
  },
  cssBgColor: {
    '1': 'BG_r',
    '2': 'BG_b',
    '3': 'BG_r'
  },
  appName: {
    '1': '起点读书',
    '2': 'QQ阅读',
    '3': '起点读书'
  },
  coinName: {
    '1': '起点币',
    '2': '书币',
    '3': '阅点'
  },
  clientJsUrls: {
    '1': ['../static/js/qda/common.js', '../static/js/qda/qd.js', '../static/js/qda/qdnative.js'],
    '2': ['../static/js/qqa/common.js', '../static/js/qqa/jsbridge.js', '../static/js/qqa/androidqq.js'],
    '3': ['../static/js/qdi/common.js', '../static/js/qdi/qd.js', '../static/js/qdi/qdnative.js']
  }
};

if (false) {
  clientConfig.httpsHost = {
    '1': 'https://devm-game.qidian.com/',
    '2': 'https://devm-game.book.qq.com/',
    '3': 'https://devp-game.qidian.com/'
  };
  clientConfig.apiHost = {
    '1': 'https://devi-game.qidian.com/',
    '2': 'https://devi-game.book.qq.com/',
    '3': 'https://devi-game.qidian.com/'
  };

  clientConfig.lyApiHost = {
    '1': 'https://lygametest.qidian.com/',
    '2': 'https://lygametest.book.qq.com/',
    '3': 'https://lygametest.qidian.com/'
  };

  clientConfig.appHost = {
    '1': 'QDReader://devm-game.qidian.com/',
    '2': 'uniteqqreader://webpage/game/https://devm-game.book.qq.com/'
    // clientConfig.apiHost = {
    //   '1': 'https://debugi-game.qidian.com/',
    //   '2': 'https://debugi-game.book.qq.com/',
    //   '3': 'https://debugi-game.qidian.com/'
    // }
  };clientConfig.mtaSid = {
    '1': '500555855',
    '2': '500513957',
    '3': '500543812'
  };
  clientConfig.mtaCid = {
    '1': '500627221',
    '2': '500633477',
    '3': '500634644'
  };
  clientConfig.mtaHid = {
    '1': '"5b7fbfadf3938"',
    '2': '"5b7d0e1328948"',
    '3': '"5b83ce214d952"'
  };
  clientConfig.newAppHosts = {
    1: 'qdgame://qdgametest.qidian.com/?_viewmode=4',
    2: 'uniteqqreader://webpage/game/https://qqgametest.book.qq.com/?_viewmode=1',
    3: 'https://qdgametest.qidian.com/'
  };
  clientConfig.newGameHosts = {
    1: 'qdgame://qdgametest.qidian.com',
    2: 'uniteqqreader://webpage/game/https://qqgametest.book.qq.com',
    3: 'QDReader://qdgametest.qidian.com'
  };
  clientConfig.newGameNoSceHosts = {
    1: 'https://qdgametest.qidian.com',
    2: 'https://qqgametest.book.qq.com',
    3: 'https://qdgametest.qidian.com'
  };
} else {
  clientConfig.httpsHost = {
    '1': 'https://m-game.qidian.com/',
    '2': 'https://m-game.book.qq.com/',
    '3': 'https://p-game.qidian.com/'
  };
  clientConfig.apiHost = {
    '1': 'https://i-game.qidian.com/',
    '2': 'https://i-game.book.qq.com/',
    '3': 'https://i-game.qidian.com/'
  };

  clientConfig.lyApiHost = {
    '1': 'https://lygame.qidian.com/',
    '2': 'https://lygame.book.qq.com/',
    '3': 'https://lygame.qidian.com/'
  };

  clientConfig.appHost = {
    '1': 'QDReader://m-game.qidian.com/',
    '2': 'uniteqqreader://webpage/game/https://m-game.book.qq.com/'
  };
  clientConfig.mtaSid = {
    '1': '500555853',
    '2': '500521695',
    '3': '500545454'
  };
  clientConfig.mtaCid = {
    '1': '500583589',
    '2': '500539047',
    '3': '500581439'
  };
  clientConfig.mtaHid = {
    '1': '"5b7fc4893fc58"',
    '2': '"5b7fc24dbe901"',
    '3': '"5b83ce5a465e8"'
  };
  clientConfig.newAppHosts = {
    1: 'qdgame://qdgame.qidian.com/?_viewmode=4',
    2: 'uniteqqreader://webpage/game/https://qqgame.book.qq.com/?_viewmode=1',
    3: 'https://qdgame.qidian.com/'
  };
  clientConfig.newGameHosts = {
    1: 'qdgame://qdgame.qidian.com',
    2: 'uniteqqreader://webpage/game/https://qqgame.book.qq.com',
    3: 'QDReader://qdgame.qidian.com'
  };
  clientConfig.newGameNoSceHosts = {
    1: 'https://qdgame.qidian.com',
    2: 'https://qqgame.book.qq.com',
    3: 'https://qdgame.qidian.com'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (clientConfig);

/***/ })

},[291]);


// WEBPACK FOOTER //
// static/js/app.93cd49311b0382dd8b76.js